import React from 'react'
import DatePicker from 'react-datepicker'

export default ({
  value,
  selected,
  ...rest
}) => (
  <DatePicker selected={value} {...rest} onBlur={() => {}} />
)



// WEBPACK FOOTER //
// ./src/components/forms/datepicker.js